(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-stat-bar"] && !Shopify.designMode) return;
  try {
    
    (() => {
      if (customElements.get('brand-stat-bar')) return;

      class BrandStatBar extends HTMLElement {
        connectedCallback() {
          this.initializationFrame = window.requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          this.initializationFrame = null;
          if (this.initialized || !this.isConnected) return;

          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-brand-stat-slide]'));
          this.previousButton = this.querySelector('[data-brand-stat-previous]');
          this.nextButton = this.querySelector('[data-brand-stat-next]');
          this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.transitionStyle = this.dataset.transitionStyle || 'fade';
          this.transitionDuration = Math.max(0, Number(this.dataset.transitionDuration) || 0);
          this.autoplayEnabled = this.dataset.autoplay === 'true';
          this.autoplayInterval = Math.max(3000, Number(this.dataset.autoplayInterval) || 5000);
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.isHovered = false;
          this.hasFocusWithin = false;
          this.isEditingBlock = false;
          this.autoplayTimer = null;
          this.animationVersion = 0;

          this.handlePrevious = () => {
            this.show(this.currentIndex - 1, -1);
            this.restartAutoplay();
          };
          this.handleNext = () => {
            this.show(this.currentIndex + 1, 1);
            this.restartAutoplay();
          };
          this.handleMouseEnter = () => {
            this.isHovered = true;
            this.stopAutoplay();
          };
          this.handleMouseLeave = () => {
            this.isHovered = false;
            this.startAutoplay();
          };
          this.handleFocusIn = () => {
            this.hasFocusWithin = true;
            this.stopAutoplay();
          };
          this.handleFocusOut = (event) => {
            if (event.relatedTarget && this.contains(event.relatedTarget)) return;
            this.hasFocusWithin = false;
            this.startAutoplay();
          };
          this.handleVisibilityChange = () => {
            if (document.hidden) this.stopAutoplay();
            else this.startAutoplay();
          };
          this.handleReducedMotionChange = () => {
            if (this.reducedMotion.matches) this.stopAutoplay();
            else this.startAutoplay();
          };
          this.handleBlockSelect = (event) => {
            if (event.detail?.sectionId !== this.dataset.sectionId) return;

            this.isEditingBlock = true;
            this.stopAutoplay();
            const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
            if (selectedIndex >= 0) {
              this.show(selectedIndex, selectedIndex >= this.currentIndex ? 1 : -1);
            }
          };
          this.handleBlockDeselect = (event) => {
            if (event.detail?.sectionId !== this.dataset.sectionId) return;
            this.isEditingBlock = false;
            this.startAutoplay();
          };
          this.handleKeydown = (event) => {
            if (this.slides.length < 2 || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
            event.preventDefault();
            if (event.key === 'ArrowLeft') this.handlePrevious();
            else this.handleNext();
          };

          this.previousButton?.addEventListener('click', this.handlePrevious);
          this.nextButton?.addEventListener('click', this.handleNext);
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          this.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

          if (typeof this.reducedMotion.addEventListener === 'function') {
            this.reducedMotion.addEventListener('change', this.handleReducedMotionChange);
          } else {
            this.reducedMotion.addListener(this.handleReducedMotionChange);
          }

          this.startAutoplay();
        }

        disconnectedCallback() {
          if (this.initializationFrame != null) window.cancelAnimationFrame(this.initializationFrame);
          if (!this.initialized) return;
          this.stopAutoplay();
          this.animationVersion += 1;
          this.slides?.forEach((slide) => slide.getAnimations().forEach((animation) => animation.cancel()));
          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          this.removeEventListener('mouseenter', this.handleMouseEnter);
          this.removeEventListener('mouseleave', this.handleMouseLeave);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
          this.removeEventListener('keydown', this.handleKeydown);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);

          if (typeof this.reducedMotion?.removeEventListener === 'function') {
            this.reducedMotion.removeEventListener('change', this.handleReducedMotionChange);
          } else {
            this.reducedMotion?.removeListener(this.handleReducedMotionChange);
          }

          this.initialized = false;
        }

        startAutoplay() {
          this.stopAutoplay();

          if (
            !this.autoplayEnabled ||
            this.slides.length < 2 ||
            this.reducedMotion.matches ||
            this.isHovered ||
            this.hasFocusWithin ||
            this.isEditingBlock ||
            document.hidden
          ) return;

          this.autoplayTimer = window.setInterval(() => {
            this.show(this.currentIndex + 1, 1);
          }, this.autoplayInterval);
        }

        stopAutoplay() {
          if (this.autoplayTimer === null) return;
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }

        restartAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
        }

        show(requestedIndex, direction = 1) {
          if (this.slides.length < 2) return;

          const nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
          if (nextIndex === this.currentIndex) return;

          const previousIndex = this.currentIndex;
          const previousSlide = this.slides[previousIndex];
          const nextSlide = this.slides[nextIndex];
          const animationVersion = ++this.animationVersion;
          const shouldAnimate = this.transitionStyle !== 'none' && this.transitionDuration > 0 && !this.reducedMotion.matches;

          this.slides.forEach((slide, index) => {
            slide.getAnimations().forEach((animation) => animation.cancel());
            if (index !== previousIndex && index !== nextIndex) slide.hidden = true;
          });

          this.currentIndex = nextIndex;
          nextSlide.hidden = false;
          nextSlide.classList.add('is-active');
          nextSlide.setAttribute('aria-hidden', 'false');
          previousSlide.classList.remove('is-active');
          previousSlide.setAttribute('aria-hidden', 'true');

          if (!shouldAnimate) {
            previousSlide.hidden = true;
            return;
          }

          const distance = direction >= 0 ? 24 : -24;
          const outgoingFrames = this.transitionStyle === 'slide'
            ? [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: `translateX(${-distance}px)` }]
            : [{ opacity: 1 }, { opacity: 0 }];
          const incomingFrames = this.transitionStyle === 'slide'
            ? [{ opacity: 0, transform: `translateX(${distance}px)` }, { opacity: 1, transform: 'translateX(0)' }]
            : [{ opacity: 0 }, { opacity: 1 }];
          const options = {
            duration: this.transitionDuration,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'both'
          };
          const outgoingAnimation = previousSlide.animate(outgoingFrames, options);
          const incomingAnimation = nextSlide.animate(incomingFrames, options);

          Promise.allSettled([outgoingAnimation.finished, incomingAnimation.finished]).then(() => {
            if (animationVersion !== this.animationVersion) return;
            previousSlide.hidden = true;
            outgoingAnimation.cancel();
            incomingAnimation.cancel();
          });
        }
      }

      customElements.define('brand-stat-bar', BrandStatBar);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const selector = '.td-header-shell[data-td-sticky="true"]';
    const controllers = new WeakMap();

    function mount(shell) {
      if (controllers.has(shell)) return;

      const header = shell.querySelector('.td-header');
      const navigation = shell.querySelector('.td-header__nav-stack');
      const toggle = shell.querySelector('.td-header__sticky-menu');
      const desktop = window.matchMedia('(min-width: 769px)');
      let stuck = false;
      let expanded = false;
      let previousScroll = 0;
      let expandedAt = 0;
      let frame = null;

      function updateFlowHeight() {
        if (stuck) {
          const navigationHeight = navigation.hasAttribute('inert') ? navigation.getBoundingClientRect().height : 0;
          const fullHeight = header.getBoundingClientRect().height + navigationHeight;
          shell.style.setProperty('--td-header-flow-height', fullHeight + 'px');
        }
      }

      function updateNavigation() {
        const collapsed = stuck && desktop.matches && !expanded;
        toggle.setAttribute('aria-expanded', String(stuck && desktop.matches && expanded));
        if (navigation.hasAttribute('inert') === collapsed) return;
        if (collapsed && navigation.contains(document.activeElement)) {
          toggle.focus({ preventScroll: true });
        }
        navigation.toggleAttribute('inert', collapsed);
        if (collapsed) {
          navigation.querySelectorAll('details[open]').forEach(details => {
            details.open = false;
            details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          });
        }
      }

      function sync() {
        frame = null;
        const scroll = Math.max(0, window.scrollY);
        const shouldStick = scroll > (stuck ? 8 : 12);
        if (shouldStick !== stuck) {
          if (shouldStick) {
            shell.style.setProperty('--td-header-flow-height', shell.getBoundingClientRect().height + 'px');
          }
          stuck = shouldStick;
          expanded = false;
          shell.classList.toggle('td-header-shell--stuck', stuck);
          updateNavigation();
          updateFlowHeight();
        }

        if (stuck) {
          if (!desktop.matches || (expanded && scroll > previousScroll && scroll >= expandedAt + 12)) {
            expanded = false;
          }
          updateNavigation();

          const previousSection = shell.closest('.shopify-section-group-header-group')?.previousElementSibling;
          const announcement = document.querySelector('.announcement-bar--sticky')
            || previousSection?.querySelector('.announcement-bar');
          const offset = Math.max(0, announcement?.getBoundingClientRect().bottom || 0);
          shell.style.setProperty('--td-header-announcement-offset', offset + 'px');
        }
        previousScroll = scroll;
      }

      function schedule() {
        if (frame === null) frame = window.requestAnimationFrame(sync);
      }

      function toggleNavigation() {
        if (!stuck || !desktop.matches) return;
        expanded = !expanded;
        expandedAt = window.scrollY;
        updateNavigation();
      }

      function closeWithEscape(event) {
        if (event.key !== 'Escape' || !expanded) return;
        expanded = false;
        updateNavigation();
      }

      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
        updateFlowHeight();
        schedule();
      }) : null;
      function refresh() {
        resizeObserver?.disconnect();
        resizeObserver?.observe(header);
        resizeObserver?.observe(navigation);
        document.querySelectorAll('.announcement-bar').forEach(bar => resizeObserver?.observe(bar));
        schedule();
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      desktop.addEventListener('change', schedule);
      toggle.addEventListener('click', toggleNavigation);
      shell.addEventListener('keydown', closeWithEscape);
      controllers.set(shell, {
        refresh,
        destroy() {
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
          desktop.removeEventListener('change', schedule);
          toggle.removeEventListener('click', toggleNavigation);
          shell.removeEventListener('keydown', closeWithEscape);
          resizeObserver?.disconnect();
          if (frame !== null) window.cancelAnimationFrame(frame);
          shell.classList.remove('td-header-shell--stuck');
          shell.style.removeProperty('--td-header-flow-height');
          shell.style.removeProperty('--td-header-announcement-offset');
          navigation.removeAttribute('inert');
          toggle.setAttribute('aria-expanded', 'false');
          controllers.delete(shell);
        }
      });
      refresh();
    }

    function initialize() {
      document.querySelectorAll(selector).forEach(mount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', () => {
      initialize();
      document.querySelectorAll(selector).forEach(shell => controllers.get(shell)?.refresh());
    });
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll(selector).forEach(shell => controllers.get(shell)?.destroy());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-line-modules"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-product-line-tabs')) {
    customElements.define('td-product-line-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-pl-panel]')) {
          this.initialize();
          return;
        }
        this.initFrame = requestAnimationFrame(() => {
          this.initFrame = null;
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        if (this.controller) return;
        this.panels = Array.from(this.querySelectorAll('[data-pl-panel]'));
        if (!this.panels.length) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.toolbar = this.querySelector('[data-pl-toolbar]');
        this.tabList = this.querySelector('[data-pl-tabs]');
        this.action = this.querySelector('[data-pl-action]');
        this.tabs = [];

        if (this.panels.length > 1) {
          this.tabList.setAttribute('role', 'tablist');
          this.tabs = this.panels.map((panel, index) => {
            const tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'td-pl__tab';
            tab.id = panel.id + '-tab';
            tab.textContent = panel.querySelector('[data-pl-label]').textContent;
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panel.id);
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
            tab.addEventListener('click', () => this.select(index), { signal });
            tab.addEventListener('keydown', (event) => this.onKey(event, index), { signal });
            return tab;
          });
          this.tabList.replaceChildren(...this.tabs);
        }
        this.tabList.hidden = !this.tabs.length;
        this.dataset.plReady = '';
        this.active = -1;
        this.select(0);

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.indexOf(event.target.closest('[data-pl-panel]'));
          if (index >= 0) this.select(index);
        }, { signal });
      }

      disconnectedCallback() {
        if (this.initFrame != null) {
          cancelAnimationFrame(this.initFrame);
          this.initFrame = null;
        }
        if (!this.controller) return;
        this.controller.abort();
        this.controller = null;
        delete this.dataset.plReady;
        this.toolbar.hidden = true;
        this.tabList.replaceChildren();
        this.action.replaceChildren();
        this.panels.forEach((panel) => {
          panel.hidden = false;
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        });
      }

      select(index) {
        if (index === this.active) return;
        this.active = index;
        this.panels.forEach((panel, current) => {
          panel.hidden = current !== index;
          const tab = this.tabs[current];
          if (tab) {
            tab.setAttribute('aria-selected', String(current === index));
            tab.tabIndex = current === index ? 0 : -1;
          }
        });
        const panel = this.panels[index];
        const rail = panel.querySelector('.td-pl__cards');
        rail.scrollLeft = 0;
        const link = panel.querySelector('[data-pl-link]');
        this.action.replaceChildren(...(link ? [link.cloneNode(true)] : []));
        this.action.hidden = !link;
        this.toolbar.hidden = !this.tabs.length && !link;

        const tab = this.tabs[index];
        if (tab) {
          const bounds = tab.getBoundingClientRect();
          const viewport = this.tabList.getBoundingClientRect();
          const offset = bounds.left < viewport.left ? bounds.left - viewport.left
            : Math.max(0, bounds.right - viewport.right);
          if (offset) this.tabList.scrollLeft += offset;
        }
      }

      onKey(event, index) {
        const last = this.tabs.length - 1;
        const dir = getComputedStyle(this.tabList).direction === 'rtl' ? -1 : 1;
        let next;
        switch (event.key) {
          case 'ArrowLeft': next = (index - dir + this.tabs.length) % this.tabs.length; break;
          case 'ArrowRight': next = (index + dir + this.tabs.length) % this.tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = last; break;
          default: return;
        }
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-home-slideshow')) {
    class TDHomeSlideshow extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.listeners) return;
        this.slides = Array.from(this.querySelectorAll('[data-td-hero-slide]'));
        if (!this.slides.length) return;

        this.listeners = new AbortController();
        this.mobile = matchMedia('(max-width: 768px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rotationButton = this.querySelector('[data-td-hero-pause]');
        this.videoButton = this.querySelector('[data-td-hero-video-toggle]');
        this.controls = this.querySelector('[data-td-hero-controls]');
        this.dots = Array.from(this.querySelectorAll('[data-td-hero-dot]'));
        this.current = 0;
        this.inView = true;
        this.userPaused = false;
        this.explicitResume = false;
        this.hovered = false;
        this.editing = false;
        this.videoChoice = null;

        const listen = (target, type, fn, options = {}) => {
          target.addEventListener(type, fn, { ...options, signal: this.listeners.signal });
        };
        listen(this, 'click', event => this.handleClick(event));
        listen(this, 'keydown', event => {
          if (this.slides.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowLeft' ? -1 : 1));
        });
        listen(this, 'focusin', event => {
          if (event.target !== this.rotationButton) this.explicitResume = false;
          this.scheduleRotation();
        });
        listen(this, 'focusout', event => {
          if (!this.contains(event.relatedTarget)) this.scheduleRotation(false);
        });
        listen(this, 'pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.explicitResume = false;
          this.scheduleRotation();
        });
        listen(this, 'pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.scheduleRotation();
        });
        for (const eventName of ['play', 'pause', 'ended']) {
          listen(this, eventName, () => this.updateVideoButton(), { capture: true });
        }
        listen(this.mobile, 'change', () => this.syncVideo());
        listen(this.reducedMotion, 'change', () => {
          this.videoChoice = null;
          this.refresh();
        });
        listen(document, 'visibilitychange', () => this.refresh());
        listen(document, 'shopify:block:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editing = true;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
          else this.scheduleRotation();
        });
        listen(document, 'shopify:block:deselect', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editing = false;
          this.scheduleRotation();
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.refresh();
          });
          this.observer.observe(this);
        }
        this.show(0);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.listeners?.abort();
        this.listeners = null;
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.video?.pause();
        this.video = null;
      }

      handleClick(event) {
        const control = event.target.closest('button');
        if (!control) return;
        if (control.hasAttribute('data-td-hero-step')) {
          this.show(this.current + Number(control.dataset.tdHeroStep));
        } else if (control.hasAttribute('data-td-hero-dot')) {
          this.show(Number(control.dataset.tdHeroDot));
        } else if (control === this.rotationButton) {
          this.userPaused = !this.userPaused;
          this.explicitResume = !this.userPaused;
          this.refresh();
        } else if (control === this.videoButton && this.video) {
          this.videoChoice = this.video.paused;
          this.syncVideo();
        }
      }

      show(index) {
        const next = (index + this.slides.length) % this.slides.length;
        if (next !== this.current) {
          if (this.slides[this.current].contains(document.activeElement)) this.focus({ preventScroll: true });
          this.video?.pause();
          this.video = null;
          this.videoChoice = null;
        }
        this.current = next;
        const slide = this.slides[next];
        const picture = slide.querySelector('[data-td-hero-picture]');
        if (picture) picture.replaceWith(picture.content.cloneNode(true));
        this.slides.forEach((item, position) => {
          const active = position === next;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
          item.inert = !active;
        });
        this.dots.forEach((dot, position) => {
          if (position === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.refresh();
      }

      refresh() {
        if (!this.isConnected) return;
        if (this.rotationButton) {
          this.rotationButton.hidden = this.reducedMotion.matches;
          this.rotationButton.textContent = this.userPaused ? '▶' : 'Ⅱ';
          this.rotationButton.setAttribute('aria-label', this.userPaused ? 'Resume slideshow' : 'Pause slideshow');
        }
        if (this.controls) this.controls.hidden = !this.controls.querySelector('button:not([hidden])');
        this.syncVideo();
        this.scheduleRotation();
      }

      scheduleRotation(focusWithin = this.contains(document.activeElement)) {
        clearTimeout(this.timer);
        if (
          !this.rotationButton || this.userPaused || this.reducedMotion.matches ||
          document.hidden || !this.inView || this.editing ||
          (focusWithin && !(this.explicitResume && document.activeElement === this.rotationButton)) ||
          (this.dataset.pauseHover === 'true' && this.hovered && !this.explicitResume)
        ) return;
        const delay = Number(this.dataset.interval) || 5000;
        this.timer = setTimeout(() => this.show(this.current + 1), delay);
      }

      syncVideo() {
        const slide = this.slides[this.current];
        const player = slide.querySelector('[data-td-hero-video-player]');
        if (player && this.inView && !document.hidden) {
          const template = (this.mobile.matches && slide.querySelector('[data-td-hero-video="mobile"]'))
            || slide.querySelector('[data-td-hero-video="desktop"]');
          if (player.dataset.variant !== template.dataset.tdHeroVideo) {
            this.video?.pause();
            player.replaceChildren(template.content.cloneNode(true));
            player.dataset.variant = template.dataset.tdHeroVideo;
          }
          this.video = player.querySelector('video');
          if (this.video) {
            this.video.muted = true;
            if (player.dataset.label) this.video.setAttribute('aria-label', player.dataset.label);
            if (this.videoChoice ?? (!this.reducedMotion.matches && !this.userPaused)) {
              this.video.play().catch(() => this.updateVideoButton());
            } else {
              this.video.pause();
            }
          }
        } else {
          this.video?.pause();
        }
        this.updateVideoButton();
      }

      updateVideoButton() {
        if (!this.videoButton) return;
        if (!this.video && this.videoButton === document.activeElement) this.focus({ preventScroll: true });
        this.videoButton.hidden = !this.video;
        if (!this.video) return;
        this.videoButton.textContent = this.video.paused ? '▶' : 'Ⅱ';
        this.videoButton.setAttribute('aria-label', this.video.paused ? 'Play video' : 'Pause video');
      }
    }

    customElements.define('td-home-slideshow', TDHomeSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
